// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c593aded","453":"857e1654"}[chunkId] + ".chunk.js";
};